import apiClient from "./api-client";

/**
 * Generates an OAuth authorization URL for the given course ID and callback URL
 * and redirects the user to that URL.
 *
 * Replaces the current iframe src with the authorization URL.
 */
export async function initiateAuthenticationRedirect({
	courseId,
	callbackUrl,
}: {
	courseId: number;
	callbackUrl: string;
}) {
	if (!courseId) {
		throw new Error("Course ID not found in portal context");
	}
	const url = await apiClient.oauth.getAuthorizationUrl({
		courseId,
		callbackUrl,
	});
	window.location.href = url;
}
